import { toCamelCase } from './camelCase'

export const commaSeparatedString = string => {
  let stringJoin = string.join(', ')?.toUpperCase()
  stringJoin = toCamelCase(stringJoin)
  return stringJoin || '-'
}
